import { attachmentDownloadUrl } from '../../api/endpoints'
import type { Attachment } from '../../api/types'
import { Icon } from '../../components/Icon'

/** A clip the worker couldn't convert: its sender can still download it as uploaded; nobody else can fetch it. */
export function ClipFailed({ attachment, download }: { attachment: Attachment; download: boolean }) {
  return (
    <div className="clip-failed">
      <Icon name="alert" />
      <span className="clip-failed-copy">
        <strong>This clip couldn't be processed</strong>
        <small>
          <span className="clip-failed-name">{attachment.fileName}</span>
          {download ? (
            <>
              {' '}
              <span aria-hidden="true">·</span>{' '}
              <a href={attachmentDownloadUrl(attachment.id)} download={attachment.fileName} aria-label={`Download ${attachment.fileName}`}>
                Download
              </a>
            </>
          ) : null}
        </small>
      </span>
    </div>
  )
}
